module.exports = __webpack_public_path__ + "img/redirect-duck.7091b81a.png";